module.exports = __webpack_public_path__ + "assets/d30816de560956b72be7201ba7b4c7a2.jpg";